"use client";

import { c as _c } from "react/compiler-runtime";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getSelection, $insertNodes, $isNodeSelection, $isRangeSelection, COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from "lexical";
import { useEffect, useRef } from "react";
import { $isListItemNode, $isListNode } from "@lexical/list";
import { $isHeadingNode } from "@lexical/rich-text";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import useCapacitor from "@/hooks/useCapacitor";
export default function EnterKeyPlugin(t0) {
  const $ = _c(14);
  const {
    disabled,
    handleSubmit,
    canSubmitWithEnter
  } = t0;
  const isMobile = useIsMobileDevice();
  const {
    isCapacitor
  } = useCapacitor();
  const disabledRef = useRef(disabled);
  const handleSubmitRef = useRef(handleSubmit);
  const canSubmitWithEnterRef = useRef(canSubmitWithEnter);
  let t1;
  let t2;
  if ($[0] !== disabled) {
    t1 = () => {
      disabledRef.current = disabled;
    };
    t2 = [disabled];
    $[0] = disabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== handleSubmit) {
    t3 = () => {
      handleSubmitRef.current = handleSubmit;
    };
    t4 = [handleSubmit];
    $[3] = handleSubmit;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== canSubmitWithEnter) {
    t5 = () => {
      canSubmitWithEnterRef.current = canSubmitWithEnter;
    };
    t6 = [canSubmitWithEnter];
    $[6] = canSubmitWithEnter;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  const [editor] = useLexicalComposerContext();
  let t7;
  let t8;
  if ($[9] !== editor || $[10] !== isCapacitor || $[11] !== isMobile) {
    t7 = () => {
      const insertParagraph = t9 => {
        const {
          forceParagraph: t10
        } = t9 === undefined ? {} : t9;
        const forceParagraph = t10 === undefined ? false : t10;
        editor.update(() => {
          const currentSelection = $getSelection();
          if ($isRangeSelection(currentSelection)) {
            currentSelection.insertParagraph();
            if (forceParagraph) {
              const updatedSelection = $getSelection();
              if ($isRangeSelection(updatedSelection)) {
                const topLevelElement = updatedSelection.anchor.getNode().getTopLevelElementOrThrow();
                if ($isHeadingNode(topLevelElement)) {
                  const paragraphNode = $createParagraphNode();
                  paragraphNode.append(...topLevelElement.getChildren());
                  topLevelElement.replace(paragraphNode);
                  paragraphNode.selectStart();
                }
              }
            }
            return;
          }
          if ($isNodeSelection(currentSelection)) {
            const paragraphNode_0 = $createParagraphNode();
            $insertNodes([paragraphNode_0]);
            paragraphNode_0.selectStart();
          }
        });
      };
      return editor.registerCommand(KEY_ENTER_COMMAND, event => {
        if (disabledRef.current || !canSubmitWithEnterRef.current()) {
          return false;
        }
        if (isMobile || isCapacitor) {
          return true;
        }
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const anchorNode = selection.anchor.getNode();
          let parentNode = anchorNode.getParent();
          if (parentNode === null) {
            parentNode = anchorNode.getTopLevelElement();
          }
          if ($isListItemNode(parentNode) || $isListNode(parentNode)) {
            return false;
          }
          if ($isHeadingNode(parentNode) && event?.shiftKey) {
            event.preventDefault();
            insertParagraph({
              forceParagraph: true
            });
            return true;
          }
        }
        if (event?.shiftKey) {
          event.preventDefault();
          insertParagraph();
          return true;
        } else {
          event?.preventDefault();
          handleSubmitRef.current();
          return true;
        }
      }, COMMAND_PRIORITY_HIGH);
    };
    t8 = [editor, isMobile, isCapacitor];
    $[9] = editor;
    $[10] = isCapacitor;
    $[11] = isMobile;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  return null;
}